<template>
    <button 
        v-bastards
        :class="[
            'button-save btn btn-c--secondary fs-21 fs-lh-26 text-bold text-left',
            themeClass,
            { 'is-disabled': isDisabled }
        ]"
        v-html="labelHtml"
    >
    </button>
</template>

<script>
import ThemeClassMixin from '@/mixins/ThemeClassMixin'

export default {
    mixins: [
        ThemeClassMixin
    ],

    props: {
        labelHtml: {
            type: String,
            required: false,
            default: ''
        },
        isDisabled: {
            type: Boolean,
            required: false,
            default: false
        }
    },

    data() {
        return {
            themeClassPrefix: 'button-save--'
        }
    }
}
</script>

<style lang="scss">
.button-save {
    position: relative;
    padding: 14px 80px 14px 53px;
    margin: 15px 0;
    max-width: 374px;
    min-height: 80px;

    .is-ie & {
        padding-right: 60px;
    }

    &:after {
        content: "\e901";
        @include transform(rotate(-90deg));
        font-family: 'noun_icon';
        position: absolute;
        top: calc(50% - 12px);
        right: 23px;
        font-size: 14px;
    }

    &--right {
        position: absolute;
        right: 0;
    }

    &--thin {
        padding: 14px 58px 14px 34px;
        min-height: 70px;
    }

    &.is-disabled {
        pointer-events: none;
        opacity: .39;
    }

    @media (max-width: $screen-page-large) {
        &--main {
            right: $value-wrapper-padding-laptop;
        }
    }

    @media (max-width: $screen-mobile-landscape) {
        font-size: 2.0rem;

        &--main {
            padding: 12px 56px 12px 33px;
            position: relative;
            right: 0;
            max-width: 100%;
            width: 100%;
            display: block;
        }
    }
}
</style>
